<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Manage Group"
              bc1="App"
              bc2="Schema"
              bc3="Manage Group"
              path="Schema"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <!-- Main Content Column -->
            <div class="col-md-8 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Groups</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal" @submit.prevent>
                    <div class="row">
                      <div class="col-md-12 user_status mb-2">
                        <div class="input-group">
                          <input class="form-control" type="text" v-model="search" placeholder="Search here..."/>
                          <div class="input-group-append">
                            <button type="button" class="btn btn-primary" @click="handleSearch" :disabled="loadingSearch">
                              <span v-if="!loadingSearch">Search</span>
                              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
<!--                            <button type="button" class="btn btn-outline-secondary" @click="clear" :disabled="loadingSearch">-->
<!--                              Reset-->
<!--                            </button>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <h6 class="section-label mx-1 mb-2">Groups</h6>
                      <div class="col-12 mb-2">
                        <div class="custom-control custom-switch mb-1" v-for="(feature,index) in featureList" :key="index">
                          <input :id="index" type="checkbox" v-if="typeof(feature.checked) != 'undefined'"
                                 class="custom-control-input" v-model="feature.checked"
                                 @change="updateSelection(feature.id, feature.checked)"/>
                          <label :class="typeof(feature.checked) != 'undefined' ? 'custom-control-label':''" :for="index">
                            {{ feature.name }}
                          </label>
                        </div>
                      </div>
                      <div class="col-12 text-center" v-if="hasMoreItems && !loadingMore">
                        <button class="btn btn-primary btn-sm" @click="loadMore">
                          Load More
                        </button>
                      </div>
                      <div class="col-12 text-center" v-if="loadingMore">
                        <div class="spinner-border text-primary" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                      <div class="col-12 text-muted text-center" v-if="!hasMoreItems && featureList.length > 0">
                        No more items to load
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- Selected Groups Panel -->
            <div class="col-md-4 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title d-flex justify-content-between align-items-center">
                    Selected Groups
                    <span class="badge badge-pill ml-1 badge-light-primary">
                      {{ Object.keys(allSelectedGroups).length }}
                    </span>
                  </h4>
                </div>
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <tbody>
                      <tr v-for="(selected, id) in allSelectedGroups" :key="id">
                        <td class="py-1">
                          {{ getGroupName(id) }}
                        </td>
                        <td class="text-right py-1">
                          <button
                              type="button"
                              class="btn btn-sm btn-icon rounded-circle"
                              @click="confirmRemoveSelection(id)"
                          >
                            <i class="fas fa-times text-danger"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="Object.keys(allSelectedGroups).length === 0">
                        <td colspan="2" class="text-center text-muted py-2">
                          No groups selected
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="card-footer d-flex justify-content-between align-items-center">
                  <button
                      type="button"
                      class="btn btn-sm btn-outline-danger"
                      @click="confirmClearAllSelections"
                      v-if="Object.keys(allSelectedGroups).length > 0"
                  >
                    Clear All
                  </button>
                  <button type="button" class="btn btn-primary" @click="sendCall" :disabled="loading">
                    <span v-if="!loading">Save</span>
                    <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
    <CustomConfirmationModal
        v-if="showConfirmationModal"
        :show="showConfirmationModal"
        :title="modalTitle"
        :message="modalMessage"
        @hide="showConfirmationModal = false"
        @confirm="executeConfirmedAction"
    />
  </div>
  <!-- END: Content-->
</template>

<script>
import CustomConfirmationModal from "@/pages/dashboard/schema/customConfirmationModal.vue";

export default {
  components: {CustomConfirmationModal},
  mounted() {
    this.getAllGroups()
  },
  data() {
    return {
      loader: false,
      featureList: [],
      intactFeatureList: [],
      alreadyCheckedGroups: {},
      allSelectedGroups: {},
      selectedGroupNames: {},
      explicitlyUnselectedGroups: {},
      loading: false,
      size: "10px",
      search: '',
      paginationData: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      loadingMore: false,
      loadingSearch: false,
      currentSearchQuery: '',
      hasLoadedInitialSelections: false,
      showConfirmationModal: false,
      modalTitle: '',
      modalMessage: '',
      pendingAction: null,
      pendingActionData: null,
    }
  },
  computed: {
    hasMoreItems() {
      return this.featureList.length < this.paginationData.total;
    }
  },
  methods: {
    confirmRemoveSelection(id) {
      const groupName = this.getGroupName(id);
      this.modalTitle = 'Confirm Removal';
      this.modalMessage = `Are you sure you want to remove "${groupName}" from selected groups?`;
      this.pendingAction = 'remove';
      this.pendingActionData = id;
      this.showConfirmationModal = true;
    },

    confirmClearAllSelections() {
      this.modalTitle = 'Confirm Clear All';
      this.modalMessage = 'Are you sure you want to remove all selected groups?';
      this.pendingAction = 'clearAll';
      this.showConfirmationModal = true;
    },

    executeConfirmedAction() {
      if (this.pendingAction === 'remove') {
        this.removeSelection(this.pendingActionData);
      } else if (this.pendingAction === 'clearAll') {
        this.clearAllSelections();
      }
      this.showConfirmationModal = false;
      this.pendingAction = null;
      this.pendingActionData = null;
    },

    // Your existing removeSelection and clearAllSelections methods remain unchanged
    removeSelection(id) {
      this.$delete(this.allSelectedGroups, id);
      this.$set(this.explicitlyUnselectedGroups, id, true);
      const item = this.featureList.find(f => f.id == id);
      if (item) item.checked = false;
    },

    clearAllSelections() {
      this.featureList.forEach(item => {
        item.checked = false;
      });
      this.allSelectedGroups = {};
      this.explicitlyUnselectedGroups = {};
    },
    clear() {
      this.search = '';
      this.currentSearchQuery = '';
      this.paginationData.currentPage = 1;
      this.featureList = [];
      this.hasLoadedInitialSelections = false; // Reset the flag
      this.getAllGroups();
    },
    handleSearch() {
      if (this.loadingSearch) return;

      this.loadingSearch = true;
      this.currentSearchQuery = this.search;
      this.paginationData.currentPage = 1;
      this.featureList = [];

      this.getAllGroups(true).finally(() => {
        this.loadingSearch = false;
      });
    },
    loadMore() {
      if (this.hasMoreItems && !this.loadingMore) {
        this.paginationData.currentPage++;
        this.getAllGroups(!!this.currentSearchQuery);
      }
    },
    updateSelection(id, isChecked) {
      if (isChecked) {
        this.$set(this.allSelectedGroups, id, true);
        this.$delete(this.explicitlyUnselectedGroups, id);
        const item = this.featureList.find(f => f.id == id) ||
            this.intactFeatureList.find(f => f.id == id);
        if (item) {
          this.$set(this.selectedGroupNames, id, item.name);
        }
      } else {
        this.$delete(this.allSelectedGroups, id);
      }
    },
    getGroupName(id) {
      return this.featureList.find(f => f.id == id)?.name ||
          this.intactFeatureList.find(f => f.id == id)?.name ||
          this.selectedGroupNames[id] ||
          `Group ${id}`;
    },
    async sendCall() {
      try {
        const valid = await this.$validator.validateAll();
        if (!valid) return;

        this.loading = true;
        const groupIds = Object.keys(this.allSelectedGroups);

        const data = {
          groups: JSON.stringify(groupIds),
          schemaId: parseInt(atob(this.$route.params.schemaId))
        };

        const callResponse = await this.makeRequest(
            "post",
            "v1/manage-schema-groups",
            data
        );

        if (!callResponse.error && callResponse.response.data.code === 200) {
          this.$router.back();
        }
      } catch (error) {
        console.error("Error saving changes:", error);
      } finally {
        this.loading = false;
      }
    },
    getAllGroups(forSearch = false) {
      this.loadingMore = true;

      let requestData = {
        paginate: true,
        page: this.paginationData.currentPage,
        perPage: this.paginationData.perPage
      };

      if (this.currentSearchQuery) {
        requestData.search = this.currentSearchQuery;
      }

      return this.makeRequest('post', 'v1/get-group', requestData, {}, false)
          .then(callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                const newItems = callResponse.response.data.data.data;

                const processedItems = newItems.map(item => ({
                  ...item,
                  checked: !!this.allSelectedGroups[item.id] &&
                      !this.explicitlyUnselectedGroups[item.id]
                }));

                if (callResponse.response.data.data.paginationData) {
                  this.paginationData = {
                    ...this.paginationData,
                    ...callResponse.response.data.data.paginationData
                  };
                }

                if (this.paginationData.currentPage === 1) {
                  this.featureList = processedItems;
                } else {
                  this.featureList = [...this.featureList, ...processedItems];
                }

                // Only call getAlreadySelectedGroups on initial load
                if (!this.hasLoadedInitialSelections) {
                  return this.getAlreadySelectedGroups()
                      .then(() => {
                        this.hasLoadedInitialSelections = true;
                      });
                }
              }
            }
          })
          .finally(() => {
            this.loadingMore = false;
          });
    },

    // Modified getAlreadySelectedGroups to only be called once
    getAlreadySelectedGroups() {
      // Return early if already loaded
      if (this.hasLoadedInitialSelections) {
        return Promise.resolve();
      }

      return this.makeRequest("post", "v1/get-schema-groups", {
        schemaId: parseInt(atob(this.$route.params.schemaId))
      },{},false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = callResponse.response.data.data;
            if(data){
              data.forEach(v => {
                if (!this.explicitlyUnselectedGroups[v.id]) {
                  this.$set(this.allSelectedGroups, v.id, true);
                  this.alreadyCheckedGroups[v.id] = true;
                  this.$set(this.selectedGroupNames, v.id, v.name);
                }
              });
            }

            this.featureList.forEach(eachFeature => {
              eachFeature.checked = !!this.allSelectedGroups[eachFeature.id] &&
                  !this.explicitlyUnselectedGroups[eachFeature.id];
            });

            if(this.intactFeatureList.length == 0) {
              this.intactFeatureList = [...this.featureList];
            }
          }
        }
      });
    },

  }
}
</script>

<style scoped>
.table td {
  vertical-align: middle;
}
.btn-icon {
  width: 24px;
  height: 24px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.card-footer {
  background-color: #f8f9fa;
}
</style>